import { PropsWithChildren, useMemo } from "react";
import {
  RowSelectionContext,
  RowSelectionContextValue,
} from "./RowSelectionContext";
import { useCreateRowSelectionStore } from "../hooks/useCreateRowSelectionStore";

interface RowSelectionProviderProps extends PropsWithChildren {
  initialSelection?: string[] | ReadonlySet<string>;
}

export const RowSelectionProvider = ({
  children,
  initialSelection,
}: RowSelectionProviderProps) => {
  const store = useCreateRowSelectionStore(initialSelection);

  const contextValue = useMemo<RowSelectionContextValue>(
    () => ({ store }),
    [store],
  );

  return (
    <RowSelectionContext.Provider value={contextValue}>
      {children}
    </RowSelectionContext.Provider>
  );
};
